/**
 * Functión que se encarga de subir el scroll a un posición específica
 * de no asignarse un valor por defecto va al inicio de la página.
 * @param value valor adonde va a ir el scroll
 */
export function scrollTop(value: number = 0) {
  document.querySelector('html').scrollTop = value;
}

export enum DomainEnum {
  BULLTICK = 'Bulltick',
  TR = 'TR',
  MSI = 'MSI',
}

export enum CustodianEnum {
  INTERACTIVE = 'Interactive Brokers',
}

export class Utils {
  public static ColorEnum = {
    positive: 'positive-color',
    negative: 'negative-color',
    neutro: 'neutral-color',
  };

  public static LogoNameFirstColor = [
    'bg-color-1',
    'bg-color-2',
    'bg-color-3',
    'bg-color-4',
    'bg-color-5',
    'bg-color-6',
    'bg-color-7',
    'bg-color-8',
    'bg-color-9',
    'bg-color-10',
  ];

  static colorByIdMap = new Map<string, string>();
  static i: number = 0;

  public static getColorById(id): string {
    let color: string;
    if (id === undefined || id === null || id === '') {
      color = this.LogoNameFirstColor[Utils.LogoNameFirstColor.length - 1];
    } else {
      if (this.colorByIdMap.has(id)) {
        color = this.colorByIdMap.get(id);
      } else {
        this.colorByIdMap.set(id, this.LogoNameFirstColor[this.i]);
        this.i = this.i + 1;
        if (this.i >= this.LogoNameFirstColor.length) {
          this.i = 0;
        }
        color = this.LogoNameFirstColor[this.i];
      }
    }
    return color;
  }

  public static formatString(text: string, values: any[]): string {
    if (text === '') {
      return 'empty text';
    }

    let i = values.length;
    while (i--) {
      text = text.replace(/\{\{|\}\}|\{(\w+)\}/g, (m, n) => {
        if (m === '{{') {
          return '{';
        }
        if (m === '}}') {
          return '}';
        }
        return values[n];
      });
    }

    return text;
  }
}
